import { ComponentPropsWithoutRef, ReactNode } from "react";
import YellowArrowIcon from "../assets/icons/arrow-left-circle-yellow.svg?react";

type Props = ComponentPropsWithoutRef<"a"> & {
  heading: string | ReactNode;
  text: string | ReactNode;
  isEditorial?: boolean;
};

export default function ContentExternalLink(props: Props) {
  const { href, heading, text, onClick } = props;

  return (
    <a
      href={href}
      target="_blank"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      rel="noreferrer"
    >
      <div className="px-[16px] py-[24px] rounded-[24px] flex items-center gap-[16px] space-between bg-secondary-soft-yellow-2">
        <div className="flex-1 flex flex-col gap-[8px]">
          <div className="text-[16px] font-bold text-secondary-bluegrey-7">
            {heading}
          </div>
          <div className="text-[14px] text-secondary-bluegrey-6">{text}</div>
        </div>
        <YellowArrowIcon className="w-[56px] h-[56px] transform rotate-180" />
      </div>
    </a>
  );
}
